import {
  ComponentStateManager,
  DataVizContainerCommonUtils,
} from '../../../common/types';
import { getBarChartDataFromOverTimeUnsegmentedResponse } from '../../over-time-unsegmented-utils';
import {
  OverTimeUnsegmentedVizData,
  OverTimeUnsegmentedVizDataResponse,
  OverTimeUnsegmentedVizExternalProps,
} from '../../types';
import {
  OverTimeUnsegmentedBarChartActions,
  OverTimeUnsegmentedBarChartState,
  OverTimeUnsegmentedBarChartUiComponentProps,
} from './types';

export const overTimeUnsegmentedBarChartDataToUiComponentProps = (
  data: OverTimeUnsegmentedVizData,
  externalProps: OverTimeUnsegmentedVizExternalProps,
  componentStateManager: ComponentStateManager<
    OverTimeUnsegmentedBarChartState,
    OverTimeUnsegmentedBarChartActions
  >,
  { t }: DataVizContainerCommonUtils
): OverTimeUnsegmentedBarChartUiComponentProps => {
  const { dataResponse, titleConfig, metricDisplayValues, metricDetailsMap } =
    data;
  const hasBenchmark = dataResponse.responseForMetrics.first()?.data.first()
    ?.datapoint.hasBenchmark;
  if (hasBenchmark) {
    throw new Error(
      'Bar chart view for overtime unsegmented queries does not support benchmark'
    );
  }
  const chartData = getBarChartDataFromOverTimeUnsegmentedResponse(
    dataResponse as OverTimeUnsegmentedVizDataResponse<false>,
    metricDisplayValues,
    metricDetailsMap,
    t
  );

  const displayConfig = {
    ...componentStateManager.state.displayState,
    ...componentStateManager.actions.displayActions,
  };

  return {
    fullScreenHandle: externalProps.fullScreenHandle,
    displayConfig,
    titleConfig,
    chartData,
    chartColors: data.chartColors,
  };
};
